import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    zIndex: 10,
  },
  parentCheckboxWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '15px',
    paddingLeft: '15px',
  },
  checkbox: {
    marginLeft: '-4px',
  },
}));

export default styles;
